<template>
  <el-tooltip v-if="overflow" effect="dark" placement="top">
    <template #content>
      <slot></slot>
    </template>

    <span class="text_overflow" :style="{ width: parentOffsetWidth + 'px' }">
      <slot></slot>
    </span>
  </el-tooltip>

  <span v-else ref="text" class="text">
    <slot></slot>
  </span>
</template>

<script>
/**
 * ComponentName: cl-overflow-tooltip
 * Author: zhangjun
 * 组件说明：文本超出父级宽度时，缩略显示并使用tooltip组件显示全部内容。
 * 			没有超出父级宽度时，按原本的内容展示。
 * eg:  <cl-overflow-tooltip parent-class-name="el-form-item">
 * 			这里是文本这里是文本这里是文本这里是文本这里是文本这里是文本这里是文本
 * 		</cl-overflow-tooltip>
 */
export default {
  name: "cl-overflow-tooltip",
  props: {
    // 父级Class
    parentClassName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      description:
        "文字超出父级宽度时，缩略显示并使用tooltip组件显示全部内容。",
      overflow: false, // 文字是否溢出
      parentOffsetWidth: 0, // 父级的宽度
    };
  },

  mounted() {
    let parent = this.$refs.text.parentElement;
    while (parent.tagName !== "BODY") {
      if (parent.classList.contains(this.parentClassName)) {
        if (this.$refs.text.offsetWidth > parent.offsetWidth) {
          this.overflow = true;
          this.parentOffsetWidth = parent.offsetWidth;
        }
        break;
      }
      parent = parent.parentElement;
    }
  },
};
</script>

<style lang="scss" scoped>
.text {
  white-space: nowrap;
}
.text_overflow {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>